import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import baustein from "baustein";


const TAB_CLASS = "tabbed-bottom-navigation__tab";

export default baustein.register("tabbed-bottom-navigation", {
    setupEvents(add) {
        add("click", `.${TAB_CLASS}`, this.onClick);
    },

    onClick(event) {
        event.preventDefault();
        const label = event.target.closest(`.${TAB_CLASS}`).text;
        analytics.event("Bottom Tab Nav", "Clicked", label).then(() => {
            globals.window.location = event.target.closest("a").href;
        });
    },
});
